// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-doc-link-productDocLink-77456 .product-doc-link-link-672f2{align-items:center;color:var(--GRAY_7);display:flex;font-family:var(--font-family-PingFangScMedium);font-size:12px}.product-doc-link-productDocLink-77456 .product-doc-link-link-672f2 .product-doc-link-title-30255{margin-left:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDocLink": "product-doc-link-productDocLink-77456",
	"link": "product-doc-link-link-672f2",
	"title": "product-doc-link-title-30255"
};
export default ___CSS_LOADER_EXPORT___;
